import { createReducer } from 'store/createReducer';
import { ConservatoryMakeModel } from 'models/ConservatoryMakeModel';
import { ConservatoryStepValid } from 'models/ConservatoryStepValid';
import {
  GUIDE_MAKE_DATA_LOADING,
  GUIDE_MAKE_DATA_LOADED,
  GUIDE_MAKE_PRODUCT_SELECTED,
  GUIDE_MAKE_VALID,
  GUIDE_MAKE_INVALID,
  ConservatoryMakeAction,
  ConservatoryMakeSelectProductAction
} from './actions';
import { GUIDE_SEASON_PRODUCT_SELECTED } from '../Season/actions';

const makeReducer = {
  [GUIDE_SEASON_PRODUCT_SELECTED]: (state: ConservatoryMakeModel) => {
    return {
      ...state,
      products: [],
      isValid: ConservatoryStepValid.Unknown
    };
  },
  [GUIDE_MAKE_VALID]: (state: ConservatoryMakeModel) => {
    return {
      ...state,
      isValid: ConservatoryStepValid.Valid
    };
  },
  [GUIDE_MAKE_INVALID]: (state: ConservatoryMakeModel) => {
    return {
      ...state,
      isValid: ConservatoryStepValid.Invalid
    };
  },
  [GUIDE_MAKE_DATA_LOADED]: (state: ConservatoryMakeModel, action: ConservatoryMakeAction) => {
    return {
      ...state,
      products: action.products,
      dataLoading: false
    };
  },
  [GUIDE_MAKE_DATA_LOADING]: (state: ConservatoryMakeModel) => {
    return {
      ...state,
      dataLoading: true
    };
  },
  [GUIDE_MAKE_PRODUCT_SELECTED]: (
    state: ConservatoryMakeModel,
    action: ConservatoryMakeSelectProductAction
  ) => {
    return {
      ...state,
      products: state.products.map(product => {
        return {
          ...product,
          selected: product.productId === action.productId
        };
      })
    };
  }
};

export default createReducer(
  {
    articleGroup: '',
    dataLoading: false,
    isValid: ConservatoryStepValid.Unknown,
    products: []
  },
  makeReducer
);
